export default {
  init() {
    // JavaScript to be fired on all pages
    $(window).on('load', function () {
      adjustPageContentPosition();
    });
    $(window).resize(adjustPageContentPosition);

    $('.header-nav__phone-icon-container > i').click(headerPhoneIconClicked);
    $('.header-nav__search-icon-container > i').click(headerSearchIconClicked);

    toggleNav();
    toggleSubjectsSection();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

/**
 * This sets the page padding-top to accomodate for the fixed navbar
 */
function adjustPageContentPosition() {
  const contentElement = $('body > .container-fluid');
  let navBarHeight = $('body > .header-nav').outerHeight();

  contentElement.css('padding-top', navBarHeight);
}

/**
 * Adds event listeners to toggle nav menu on toggler & close-button click
 */
function toggleNav() {
  $('.header-nav__toggler').click(() => {
    $('.header-nav__nav-container').toggleClass('js-menu-open');
  });

  $('.header-nav__close-button').click(() => {
    $('.header-nav__nav-container').toggleClass('js-menu-open');
  });
}

/**
 * Expands subjects container when toggle button is clicked on mobile
 */
function toggleSubjectsSection() {
  const toggleBtn = $('.subjects__toggle-btn');
  const cardContainer = $('.subjects__js-card-container');

  toggleBtn.click(() => {
    toggleBtn.toggleClass('js-subjects-open');

    if (toggleBtn.hasClass('js-subjects-open')) {
      cardContainer.slideDown('fast');
    } else {
      cardContainer.slideUp('fast');
    }
  });
}

/**
 * Toggles needed class on header phone icon click
 */
function headerPhoneIconClicked() {
  $('.header-nav__secondary-nav-icons').toggleClass('js-phone-icon-expanded');
}

/**
 * Toggles needed class on header search icon click
 */
function headerSearchIconClicked() {
  $('.header-nav__secondary-nav-icons').toggleClass('js-search-icon-expanded');
}


// WEBPACK FOOTER //
// ./scripts/routes/common.js